export const listOfFiltersReducerKey = 'listOfFilters';

export const requiredParamsForFilterRequest = ['context', 'databaseId', 'resultName', 'hitSetKey'];

export const filtersFetchedType = 'FILTERS_FETCHED_TYPE';
export const updateFiltersType = 'UPDATE_FILTERS_TYPE';
export const updateFilterByIdType = 'UPDATE_FILTER_BY_ID_TYPE';
export const updateGroupByIdType = 'UPDATE_GROUP_BY_ID_TYPE';
export const addFilterGroupsByIdType = 'ADD_FILTER_GROUPS_BY_ID_TYPE';
export const updateCustomGroupsByIdType = 'updateCustomGroupsByIdType';
export const updateChunksFilterByIdType = 'updateChunksFilterByIdType';
export const updateGroupByIdInChunksOfFilterType = 'updateGroupByIdInChunksOfFilterType';
export const deselectAllChunksOfFilterType = 'deselectAllChunksOfFilterType';
export const selectAllChunksOfFilterType = 'selectAllChunksOfFilterType';
export const syncAllChunksWithGroupsType = 'syncAllChunksWithGroupsType';
export const updateThesaurusType = 'updateThesaurusType';
export const updateThesaurusGroupByIdType = 'updateThesaurusGroupByIdType';
export const selectThesaurusGroupByIdType = 'selectThesaurusGroupByIdType';
export const syncThesaurusItemsWithGrouopsType = 'syncThesaurusItemsWithGrouopsType';
export const clearAllSelectedItemsInThesaurusType = 'clearAllSelectedItemsInThesaurusType';
